import { c as _c } from "react/compiler-runtime";
import { isLanguage, LANGUAGES, SUPPORTED_LANGUAGES } from '@onefootprint/core';
import { IcoLang16 } from '@onefootprint/icons';
import { Select } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
const LanguageSelect = () => {
  const $ = _c(10);
  const {
    i18n
  } = useTranslation();
  const {
    language
  } = i18n;
  if (!isLanguage(language)) {
    return null;
  }
  let t0;
  if ($[0] !== i18n || $[1] !== language) {
    t0 = newValue => {
      if (newValue === language) {
        return;
      }
      i18n.changeLanguage(newValue);
      document.documentElement.setAttribute("lang", newValue);
    };
    $[0] = i18n;
    $[1] = language;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleLanguageChange = t0;
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = SUPPORTED_LANGUAGES.map(_temp);
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== language) {
    t2 = () => <div className="flex items-center justify-center gap-1 no-underline text-secondary hover:underline hover:underline-offset-2 hover:decoration-2 text-caption-1"><IcoLang16 color="secondary" /><span className="text-caption-1">{language.toUpperCase()}</span></div>;
    $[4] = language;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== handleLanguageChange || $[7] !== language || $[8] !== t2) {
    t3 = <Select value={language} onChange={handleLanguageChange} options={t1} size="compact" customTrigger={t2} />;
    $[6] = handleLanguageChange;
    $[7] = language;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
export default LanguageSelect;
function _temp(lng) {
  return {
    value: lng,
    label: LANGUAGES[lng].nativeName
  };
}